module.exports = __webpack_public_path__ + "img/novocare-mobile-app-ryblesus-screen.fe2f84a2.png";